(async () => {
    const { Core } = await importModule('Core');
    const { Routes, parseHTML } = await importModule('Utils');

    const CART_R_SECTION = 'r_cart';
    const NOTIFICATION_SECTION = 'r_cart-notification';
    const ATTR_IS_CART_PAGE = 'cart-page';
    const SECTION_DRAWER = 'g_cart-drawer';

    customElements.define('cart-provider', class extends Core {
        subscriptions = {
            'cart:add-feature': '_addFeature',
            'cart:add': '_add',
            'cart:change': '_update'
        };

        features = {};

        render() {
            this.subscribe('cart:add-feature', { global: true });
            this.subscribe('cart:add', { global: true });
            this.subscribe('cart:change', { global: true });
        }

        _addFeature({ feature }) {
            this.features[feature] = true;
        }

        async _add({ items }) {
            try {
                const body = { items };
                if (this.features.notification) {
                    body.sections = [NOTIFICATION_SECTION];
                    body.attributes = {
                        notification_items_variant_ids: items.map(({ id }) => id).join(',')
                    };
                }

                const response = await this._requestCart('cartAdd', body);
                this._cleanCartAttributes();

                if (this.redirectToCart) {
                    window.location.pathname = Routes('cart');
                    return;
                }

                const cartData = await response.json();
                if (!response.ok) {
                    throw new Error(JSON.stringify({
                        message: cartData.message,
                        description: cartData.description
                    }));
                }

                this._publishUpdates(cartData);
            } catch (error) {
                console.error(error);
                let message = '';
                let description = '';
                try {
                    ({ message = '', description = '' } = JSON.parse(error.message));
                } catch (parseError) {
                    message = error.message || '';
                }
                if (message || description) {
                    this.publish('toast-notification:open', {
                        title: message,
                        message: description,
                        type: 'error'
                    });
                }
                this.publish('cart:error');
            }
        }

        _cleanCartAttributes() {
            if (this.features.notification) {
                this._requestCart('cartUpdate', {
                    attributes: { notification_items_variant_ids: null }
                });
            }
        }

        async _update({ key, quantity, selling_plan }) {
            const response = await this._requestCart('cartChange', {
                id: key,
                quantity,
                selling_plan,
                sections: [CART_R_SECTION],
                sections_url: Routes('cart')
            });
            const cartData = await response.json();
            this._publishUpdates(cartData);
        }

        async _publishUpdates(cartData) {
            const eventData = {};

            if (this.features['cart-total'] || this.features.counter || this.features.drawer) {
                eventData.meta = await this._getCartMeta();
            }

            if (this.features.drawer) {
                eventData.drawer = {
                    section: await this._getDrawerSection(),
                    open: !this.features.notification
                };
            }

            if (this.features.notification) {
                eventData.notification = {
                    section: cartData.sections?.[NOTIFICATION_SECTION],
                    recommendationProductId: cartData.items?.[0]?.product_id
                };
            }

            if (this.features.cart) {
                const sectionHtml = cartData.sections?.[CART_R_SECTION];
                if (sectionHtml) {
                    const cartDocument = parseHTML(sectionHtml);
                    eventData.cart = {
                        getCount: () => cartDocument.querySelector('[data-cart-counter]').innerText,
                        getItems: () => cartDocument.querySelector('[data-cart-items]'),
                        getSubtotalBlock: () => cartDocument.querySelector('[data-cart-subtotal-block]'),
                        getFreeShippingBlock: () => cartDocument.querySelector('[data-cart-free-shipping-block]')
                    };
                }
            }

            this.publish('cart:update', eventData);
        }

        async _getCartMeta() {
            const response = await fetch(`${Routes('cart')}?view=meta`);
            const { count, ...data } = await response.json();
            return { count: Number(count), ...data };
        }

        async _getDrawerSection() {
            const response = await fetch(`${Routes('root')}?section_id=${SECTION_DRAWER}`);
            return response.text();
        }

        _requestCart(route, body) {
            return fetch(`${Routes(route)}.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(body)
            });
        }

        get isCartPage() {
            return this.hasAttribute(ATTR_IS_CART_PAGE);
        }

        get redirectToCart() {
            return !this.isCartPage
                && !this.features.notification
                && !this.features.drawer;
        }
    });

})();
